import { ButtonVariant } from '@/shared/components/Buttons';
import type { UpdateStatusDialogProps } from '@/epics/adminManagment/pages/adminList/UpdateStatusDialog';
import { AdminStatusSwitchIcon } from '@/epics/adminManagment/pages/adminList/AdminStatusDialogContent';
import { FACILITY_LABELS as TL } from '../../constants/translations/facilityLabels';

export type EmployeeStatusDialogConfig = Pick<
  UpdateStatusDialogProps,
  | 'title'
  | 'content'
  | 'confirmButtonLabel'
  | 'confirmButtonLabelLoading'
  | 'icon'
  | 'confirmButtonVariant'
>;

export function getEmployeeStatusDialogConfig(
  employeeName: string,
  isActive: boolean
): EmployeeStatusDialogConfig {
  const isActivating = !isActive;
  return {
    title: isActivating
      ? TL.EMPLOYEE_DIALOG_TITLE_ACTIVATE.polish
      : TL.EMPLOYEE_DIALOG_TITLE_DEACTIVATE.polish,
    content: (
      <>
        <span>
          {isActivating
            ? TL.EMPLOYEE_DIALOG_CONFIRM_PREFIX_ACTIVATE.polish
            : TL.EMPLOYEE_DIALOG_CONFIRM_PREFIX_DEACTIVATE.polish}
        </span>
        <span className="font-medium">{employeeName}</span>
        <span>?</span>
      </>
    ),
    confirmButtonLabel: isActivating ? 'Aktywuj' : 'Dezaktywuj',
    confirmButtonLabelLoading: isActivating
      ? 'Aktywowanie…'
      : 'Dezaktywowanie…',
    icon: <AdminStatusSwitchIcon isActivating={isActivating} />,
    confirmButtonVariant: isActivating
      ? ButtonVariant.Success
      : ButtonVariant.Error,
  };
}
